import wrapLabelAndError from '../../behaviors/wrap_label_and_error';
import SelectFieldWithDatatest from '../SelectFieldWithDatatest/SelectFieldWithDatatest';

const SelectFieldWithLabelDatatest = wrapLabelAndError(SelectFieldWithDatatest);

export default SelectFieldWithLabelDatatest;
